import React, { Component } from 'react';
import { connect } from 'react-redux';
import { colorsArr } from './constants/ColorPalettes';
import { quotesArr } from './constants/QuotesText';
import { contrast } from '../../helpers/colors';
import uuid from 'uuid';
import './Quotes.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}

class Quotes extends Component {
  constructor(props) {
    super(props);
    this.renderColorQuote = this.renderColorQuote.bind(this);
  }

  renderColorQuote(color) {
    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      }
    }

    const randomQuote = quotesArr[Math.floor(Math.random() * quotesArr.length)];

    return (
      <div
        key={uuid.v4()}
        className="color-quote-container"
        style={{
          backgroundColor: color,
          color: contrast(color)
        }}>
        <div className="quote-text" style={styles.primaryFont}>
          {randomQuote.quote}
        </div>
        <div className="quote-author-text" style={styles.secondaryFont}>
          {randomQuote.author}
        </div>
      </div>
    )
  }

  render() {
    const randomScheme = colorsArr[Math.floor(Math.random() * colorsArr.length)];
    let leftColumn = randomScheme.slice(0, 3);
    let rightColumn = randomScheme.slice(3, 5);

    // 50% of the time, swap the squares
    if (Math.random() >= 0.5) {
      [leftColumn, rightColumn] = [rightColumn, leftColumn];
    }

    const leftGreater = leftColumn.length > rightColumn.length;

    return (
      <div className="quotes-wrapper">
        <div className={leftGreater ? 'quotes-left' : 'quotes-left quotes-offset'}>
          {leftColumn.map((color) => {
            return this.renderColorQuote(color);
          })}
        </div>
        <div className={leftGreater ? 'quotes-right quotes-offset' : 'quotes-right'}>
          {rightColumn.map((color) => {
            return this.renderColorQuote(color);
          })}
        </div>
        <div className="clear"></div>
      </div>
    )
  }
}

export default Quotes = connect(mapStateToProps, undefined)(Quotes);



// WEBPACK FOOTER //
// ./src/components/generator/Quotes.jsx